import { mergeQueryString } from 'bernie-core';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkNotificationBadge1 } from 'uitk-react-badge';
import { UitkButtonSize } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
import { SecondaryButtonTracked } from '../../../utils/click-trackers';
import { useStores } from '../../../utils/hooks';
export var SortFilterDialogButton = function () {
  var _a;
  var activitySearchStore = useStores().activitySearchStore;
  var history = useHistory();
  var location = useLocation();
  var href = "".concat(location.pathname, "?").concat(mergeQueryString(location.search, {
    pwaDialog: 'filter'
  }));
  var revealAction = (_a = activitySearchStore.universalSortAndFilter) === null || _a === void 0 ? void 0 : _a.revealAction;
  var handleClick = function (event) {
    event.preventDefault();
    var query = mergeQueryString(history.location.search, {
      pwaDialog: 'filter'
    });
    history.push({
      pathname: location.pathname,
      search: query,
      state: {}
    });
  };
  return React.createElement(UitkSpacing, {
    margin: {
      blockend: 'six'
    }
  }, React.createElement(SecondaryButtonTracked, {
    "data-testid": "sort-filter-dialog-button",
    rfrr: revealAction === null || revealAction === void 0 ? void 0 : revealAction.action.analytics.referrerId,
    linkName: revealAction === null || revealAction === void 0 ? void 0 : revealAction.action.analytics.linkName,
    id: "sort-and-filter-button",
    "aria-label": revealAction === null || revealAction === void 0 ? void 0 : revealAction.accessibility,
    type: "button",
    role: "button",
    isFullWidth: true,
    size: UitkButtonSize.MEDIUM,
    onClick: handleClick,
    href: href
  }, (revealAction === null || revealAction === void 0 ? void 0 : revealAction.badge) ? React.createElement(UitkNotificationBadge1, {
    text: revealAction.badge
  }) : React.createElement(UitkIcon, {
    name: "tune"
  }), revealAction === null || revealAction === void 0 ? void 0 : revealAction.primary));
};